type Cleanup = () => void;
type Handler = (root: HTMLElement, ...params: string[]) => Promise<Cleanup | void>;

const routes: [RegExp, Handler][] = [];
let root: HTMLElement;
let cleanup: Cleanup | void;

export function route(pattern: RegExp, handler: Handler): void {
  routes.push([pattern, handler]);
}

export function navigate(path: string): void {
  history.pushState(null, "", path);
  void render();
}

async function render(): Promise<void> {
  cleanup?.();
  cleanup = undefined;
  window.scrollTo(0, 0);
  for (const [pattern, handler] of routes) {
    const match = location.pathname.match(pattern);
    if (!match) continue;
    try {
      cleanup = await handler(root, ...match.slice(1));
    } catch (err) {
      root.replaceChildren(errorPage(err instanceof Error ? err.message : String(err)));
    }
    return;
  }
  root.replaceChildren(errorPage("Cette page n'existe pas."));
}

function errorPage(message: string): HTMLElement {
  const page = document.createElement("div");
  page.className = "error-page";
  const title = document.createElement("h1");
  title.textContent = "Oups";
  const text = document.createElement("p");
  text.textContent = message;
  const link = document.createElement("a");
  link.href = "/";
  link.className = "btn btn-primary";
  link.textContent = "Retour au programme";
  page.append(title, text, link);
  return page;
}

export function start(el: HTMLElement): void {
  root = el;
  window.addEventListener("popstate", () => void render());
  void render();
}
